import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Register necessary components
ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ dataArray, labelKey, valueKey, bgcolors, cutout, legendPadding }) => {
  const data = {
    labels: dataArray.map(item => item[labelKey]),
    datasets: [
      {
        data: dataArray.map(item => parseFloat(item[valueKey])),
        backgroundColor: bgcolors,
        borderWidth: 2,
        hoverOffset: 4, // Add a hover effect
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true ,
    aspectRatio: 2,
    cutout: cutout, // This makes it a donut chart instead of a pie chart
    plugins: {
      legend: {
        display: true,
        position: 'right',
        labels: {
          usePointStyle: true, // Circular points in legend
          padding: 10, // Add padding between legend items
          generateLabels: (chart) => {
            const labels = chart.data.labels;

            return labels.map((label, i) => {
              const percentage = dataArray.find(item => item[labelKey] === label).valuePct;
              return {
                text: `${label}: ${percentage}`, // Add percentage next to the category
                fillStyle: chart.data.datasets[0].backgroundColor[i],
                strokeStyle: chart.data.datasets[0].backgroundColor[i],
                lineWidth: 2,
                hidden: false,
                index: i,
              };
            });
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || '';
            const percentage = dataArray.find(item => item[labelKey] === label).valuePct;
            return `${label}: ${percentage}`;
          },
        },
      },
    },
  };

  return <Doughnut data={data} options={options} />;
};

export default PieChart;
